import Vue from 'vue';

export default {

    SET_SEARCHTERM(state, searchTerm) {
        state.searchTerm = searchTerm;
    },

    SET_SELECTED_FLEET_FOR_DATA_DISPLAY(state, value) {
        state.selectedFleet = value;
    },

    SET_NUMBER_VEHICLES_TO_INSPECT(state, value) {
        state.numberVehiclesToInspect = value;
    },
    SET_NUMBER_REQUESTS(state, value) {
        state.numberRequests = value;
    },

    CHANGE_FLEET_DISPLAY_CONFIG(state, payload) {
        if (state.api.bases[payload.uid]) {
            state.api.bases[payload.uid].display_config = payload.display_config;
        }
    },
    SET_EXTREME_VEHICULES_INSPECTION_COUNT(state, value) {
        state.extremeVehiculesInspectionCount = value;
    }

};



// WEBPACK FOOTER //
// ./src/store/mutations.js